import GetOrdersByCustomerId from "../queries/GetOrdersByCustomerId.orders.js";
import Logger from "@cappelendamm/logger";
export const fetchOrdersByCustomerId = async ({ customerId }, { client }) => {
    const result = await fetchOrdersByCustomerIdResult({ customerId }, { client });
    return result.orders;
};
export const fetchOrdersByCustomerIdResult = async ({ customerId }, { client }) => {
    try {
        const data = await client.orders.request(GetOrdersByCustomerId, {
            customerId,
        });
        return {
            ok: true,
            orders: getOrderData(data),
        };
    }
    catch (error) {
        Logger.error("Error fetching orders by customer ID:", error);
        return {
            ok: false,
            orders: [],
        };
    }
};
const getOrderData = (data) => {
    return data.orders.getAll?.edges?.map((edge) => edge.node) ?? [];
};
